export default __webpack_public_path__ + "static/frc-b870419bbad50604dd9161e616d070d9.jpg";